<template>
    <div>
        <svg :width="iconSize" :height="iconSize" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M19.7343 6.375C20.1322 6.375 20.5147 6.434 20.8742 6.54329V6.375C20.8742 4.64911 19.4751 3.25 17.7492 3.25H13.7089C13.5017 3.25 13.303 3.16769 13.1565 3.02118L10.9468 0.811468C10.5073 0.37193 9.91111 0.125 9.28951 0.125H5.24922C3.52333 0.125 2.12422 1.52411 2.12422 3.25V6.54325C2.48368 6.43399 2.86613 6.375 3.26402 6.375H19.7343Z"
                :fill="color" 
            />
            <path
                d="M3.26411 7.9375C1.83782 7.9375 0.742211 9.20075 0.943918 10.6127L1.83678 16.8627C2.00172 18.0174 2.9906 18.875 4.15697 18.875H18.8415C20.0079 18.875 20.9968 18.0174 21.1617 16.8627L22.0546 10.6127C22.2563 9.20075 21.1607 7.9375 19.7344 7.9375H3.26411Z"
                :fill="color" 
            />
        </svg>
    </div>
</template>

<script>
export default {
    name: 'IconSvgFolder2',
    props: {
        color: {
            type: String,
            default: '#000000',
        },
        size: {
            type: Number,
            default: null
        }
    },
    computed: {
        iconSize() {
            return this.size ? `${this.size}px` : '44px'
        }
    }
};
</script>

<style scoped></style>